module.exports = __webpack_public_path__ + "img/txdk-on.406f7a17.svg";